import React from 'react';
import styles from '../ActionButtons.module.less';
import { IconPillSizeOptionsEnum } from '@inter-ikea-kompis/component-icon-pill';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../../services/L10n';
import { TOP } from '../../Popup/alignments';
import Tooltip from '../../Popup/Tooltip';
import platform from '../../../util/platform';
import { IconPill } from '../../IconPill';
import {
  selectIsMobile,
  selectIsMobilePortrait,
} from '../../../state/userAgent/userAgentSelectors';
import {
  selectIsMeasurementsActive,
  selectIsWallResizerActive,
} from '../../../state/scene/sceneSelectors';
import { thunkToggleMeasurements } from '../../../state/scene/sceneThunks';
import { actionSetWallResizerInactive } from '../../../state/scene';
import { t } from '../../../translations';

const Measurements: React.FC = () => {
  const dispatch = useDispatch();
  const toggleMeasurements = () => dispatch(thunkToggleMeasurements());

  const measurementsActive = useSelector(selectIsMeasurementsActive);
  const wallResizerActive = useSelector(selectIsWallResizerActive);
  const isMobile = useSelector(selectIsMobile);
  const isMobilePortrait = useSelector(selectIsMobilePortrait);

  /**
   * On click
   */
  const onClick = (): void => {
    if (!(wallResizerActive && !isMobilePortrait)) {
      toggleMeasurements();
    }
    wallResizerActive &&
      dispatch(actionSetWallResizerInactive({ nonInteraction: true }));
  };

  /**
   * Get correct translation based on if measurements is active
   */
  const getMeasurementsActiveTranslation = (): string =>
    measurementsActive
      ? translate(t.BUTTON_HIDE_MEASURES)
      : translate(t.BUTTON_SHOW_MEASURES);

  /**
   * Get icon pill size based on whether platform is kiosk or not
   */
  const getIconPillSize = (): IconPillSizeOptionsEnum =>
    platform.isKiosk
      ? IconPillSizeOptionsEnum.medium
      : IconPillSizeOptionsEnum.small;

  /**
   * Returns boolean whether icon pill should be disabled
   */
  const disableIconPill = (): boolean =>
    !wallResizerActive || isMobilePortrait
      ? !!(wallResizerActive && !isMobilePortrait)
      : true;

  return !wallResizerActive || isMobile ? (
    <div className={styles.wrapper}>
      <Tooltip alignment={TOP} content={getMeasurementsActiveTranslation()}>
        <IconPill
          iconName="RulerIcon"
          iconPillSize={getIconPillSize()}
          onSelect={onClick}
          selected={measurementsActive}
          disabled={disableIconPill()}
          data-testid="measurements-button"
        />
      </Tooltip>
    </div>
  ) : null;
};

export default Measurements;
